module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAHCAYAAADebrddAAAAhElEQVQYlXXPQQqBURTF8SulkGzBJkyUMrUJEwMDy2HCwMQuTAyURcgiJGby08v76uvFqTM59/zr3EDpNqZolLey2MHBV+sSqBe7OOKJFd7Y1IGq2MMJD0xytsjADs2q3McZd4yLWXO8sE9ACra4YfTj2eRZBpZpzyAiWhFxif8aRsT1A5Wv3HvjTPv0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./products/390/resource/sai-icon_shape.png
// module id = L7L2
// module chunks = 0